import { AsyncPipe } from "@angular/common";
import { Component, inject, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { CheckboxComponent } from "@components/checkbox/checkbox.component";
import { LabelComponent } from "@components/label/label.component";
import { TextareaComponent } from "@components/textarea/textarea.component";
import { TogglePanelComponent } from "@components/toggle-panel/toggle-panel.component";
import { Observable, of } from "rxjs";
import { switchMap, tap } from "rxjs/operators";
import { ObjectUtils } from "~app/common/utils/object-utils";
import { UpdateKontraktNvbCommand } from "../../commands/kontrakt-nvb/UpdateKontraktNvbCommand";
import { VKKontraktNvbResponseDto } from "../../dto/kontrakt/kontrakt-nvb-dto";
import { AvtalMediatorService } from "../../services/avtal-mediator.service";
import { AvtalService } from "../../services/avtal.service";
import { KontraktCommandService } from "../../services/kontrakt-command.service";
import { KontraktMediatorService } from "../../services/kontrakt-mediator.service";

@Component({
    selector: "rask-kontrakt-nvb",
    templateUrl: "./kontrakt-nvb.component.html",
    styleUrls: ["./kontrakt-nvb.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        TogglePanelComponent,
        LabelComponent,
        FormsModule,
        TextareaComponent,
        CheckboxComponent,
        AsyncPipe
    ]
})
export class KontraktNvbComponent {
    protected readonly nvb$: Observable<VKKontraktNvbResponseDto>;

    protected kompletterandeInformation: string;
    protected kontraktGuid: string;

    private readonly avtalMediatorService = inject(AvtalMediatorService);
    private readonly avtalService = inject(AvtalService);
    private readonly kontraktCommandService = inject(KontraktCommandService);
    private readonly kontraktMediatorService = inject(KontraktMediatorService);

    constructor() {
        this.nvb$ = this.kontraktMediatorService.kontrakt$.pipe(
            tap((kontrakt) => this.kontraktGuid = kontrakt.guid),
            switchMap((kontrakt) => ObjectUtils.hasValue(kontrakt.id)
                ? this.avtalService.getKontraktNvb(kontrakt.id)
                : of(null)),
            tap((nvb) => this.kompletterandeInformation = nvb?.kompletterandeInformation));
    }

    protected kompletterandeInfoChanged() {
        const command = new UpdateKontraktNvbCommand(this.avtalMediatorService.avtal.guid, this.kontraktGuid, this.kompletterandeInformation);
        this.kontraktCommandService.update(command);
    }
}
